/*
 * Variables.ts
 * Description: Contains all variables
 */

// API url
export const APIURL = 'https://api.foodninja.net/api/v1/'; // https://jk.ekarton.net

// Google Maps JavaScript API Key
export const GMJSAK = 'AIzaSyAPUXJfbIbtjkkEhKFvxxYt0Qvv50IVJk0';

// Missing elements error message
export const MissingFirstName = 'Липсващо име.';
export const MissingLastName = 'Липсваща фамилия.';
export const MissingEmail = 'Липсваща електронна поща.';
export const MissingPhone = 'Липсващ телефонен номер.';
export const MissingPassword = 'Липсваща парола.';
export const MissingPasswordConf = 'Липсваща потвърдена парола.';
export const MissingTown = 'Липсващ град.';
export const MissingAddress = 'Липсващ адрес.';
export const MissingNotes = 'Липсващи бележки.';
export const MissingMinOrder = 'Липсваща минимална поръчка.';
export const MissingExpensiveness = 'Липсваща стойност.';
export const MissingLegalName = 'Липсваща търговско име.';
export const MissingCeo = 'Липсващ управител.';
export const MissingDescription = 'Липсващо описание.';
export const MissingWorkingHours = 'Липсващо работно време.';
export const MissingDeliveryPrices = 'Липсващи цени за доствка.';
export const MissingIngredients = 'Липсващи съставки.';
export const MissingTags = 'Липсващи тагове.';
export const MissingAddons = 'Липсващи добавки.';
export const MissingVariations = 'Липсващи вариации.';
export const MissingImage = 'Липсваща снимка.';
export const MissingSize = 'Липсващ размер.';
export const MissingText = 'Липсващ текст.';
export const MissingFrom = 'Липсваща начална дата.';
export const MissingTo = 'Липсваща крайна дата.';
export const MissingTotalCoupon = 'Липсващ общ брой на промо кодовете.';
export const MissingDiscount = 'Липсващ процент намаление.';
export const MissingExpiration = 'Липсващ дата на изтичане.';

// Passwords mismatch error message
export const PasswordsMismatch = 'Паролите не съвпадат.';

// Too long elements
export const TooLongFirstName = 'Името е прекалено дълго.';
export const TooLongLastName = 'Фамилията е прекалено дълга.';
export const TooLongEmail = 'Електронната поща е прекалено дълга.';
export const TooLongPhone = 'Телефонът е прекалено дълъг.';
export const TooLongAddress = 'Адресът е прекалено дълъг.';
export const TooLongNotes = 'Бележките са прекалено дълги.';
export const TooLongLegalName = 'Търговското име е прекалено дълго.';
export const TooLongCeo = 'Името на упрвителя е прекалено дълго.';
export const TooLongText = 'Прекалено дълъг текст.';
export const TooLongFrom = 'Прекалено дълга начална дата.';
export const TooLongTo = 'Прекалено дълга крайна дата.';

// Invalid elements
export const InvalidMinOrder = 'Минималната поръчка не може да бъде по-малка от 0.';
export const InvalidExpensiveness = 'Минималната стойност не може да бъде по-малка от 1.';
export const InvalidEmail = 'Невалидна електронна поща.';
export const InvalidCookTime = 'Невалидно време за готвене.';
export const InvalidImage = 'Снимката трябва да е квадратна.';
export const InvalidCode = 'Кодът е прекалено дълъг.';
export const InvalidTotalCoupon = 'Невалиден брой промо кодове.';
export const InvalidDiscount = 'Невалидено намаление.';

// Success
export const Success = 'Успех!';
export const SuccessfulAction = 'Действието изпълнено успешно!';
export const SuccessfullyDelivered = 'Поръчката беше доставена успешно!';
export const Warning = 'Внимание!';
export const DeletedSuccessful = 'Това действие е необратимо, желаете ли да продължите?';

export const SelectDelivery = 'Назначаване на доставчик';
export const SuccessfullySelected = 'Доставчикът бе назначен успешно!';

// Minimal password length
export const PasswordLength = 6;
// Password below minimum length message
export const PasswordBelowMin = 'Паролата трябва да е поне 6 символа.';

// Email Regex
export let EmailRegex = new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|' +
    '(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|' +
    '(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,24}))$');
// Email taken already message
export const EmailTaken = 'Избраната електронна поща вече е заета.';

// Wrong credentials message
export const WrongCredentials = 'Грешни потребителски данни.';

// Invalid old password
export const OldPassword = 'Старата парола е неправилна.';

// Changes saved
export const ChangesSaved = 'Промените са съхранени.';

// Too many attempts message
export const TooManyAttempts = 'Твърде много неуспешни опити.';

// Phone Regex
export let PhoneRegex = new RegExp('\\(?([0-9]{3})\\)?([ .-]?)([0-9]{3})\\2([0-9]{4})');
// Invalid phone message
export const PhoneInvalid = 'Невалиден телефонен номер.';

// Product Tags
export const TagsProduct = [
    'Веган', 'Най-продаван', 'Био', 'Еко',
    'Съдържа глутен', 'Съдържа лактоза',
    'Съдържа палмово масло',
];

// Restaurant Tags
export const TagsRestaurant = [
    'Българска кухня', 'Азиатска кухня', 'Турска кухня',
    'Индийска кухня', 'Италианска кухня', 'Гръцка кухня',
    'Мексиканска кухня', 'Бургери', 'Бързо хранене', 'Пици', 'Суши',
];

// Roles
export const Roles = ['Administrator', 'Manager', 'User', 'Staff', 'Social', 'Delivery'];
export const RolesStaff = ['Manager', 'Staff', 'Delivery'];

// Permissions
export const Permissions = [
    'Create Orders', 'Create Products', 'Create Restaurants',
    'Create Lunch Menus', 'Edit Restaurants', 'Edit Products',
    'Edit Lunch Menus', 'Read Stats', 'Read Orders History',
    'Manage Orders', 'Manage Staff', 'Manage Users',
    'Manage System', 'Manage Donations', 'Manage Deliveries',
    'Delete Restaurants',
];
export const PermissionsStaff = [
    'Create Products', 'Create Lunch Menus', 'Edit Restaurants', 'Edit Products',
    'Edit Lunch Menus', 'Read Stats', 'Manage Orders', 'Read Orders History',
    'Manage Staff', 'Create Restaurants', 'Manage Deliveries',
];

export const OrderOptions = [
    {
        text: 'Обработва се',
        value: 'PENDING',
    },
    {
        text: 'Приета',
        value: 'ACCEPTED',
    },
    {
        text: 'Приготвя се',
        value: 'COOKING',
    },
    {
        text: 'Доставя се',
        value: 'DELIVERING',
    },
    {
        text: 'Доставена',
        value: 'DELIVERED',
    },
];

